import React from 'react';
import {
  Box,
  CircularProgress,
  CircularProgressProps,
  Typography,
} from '@mui/material';

interface ICircularProgress {
  value: number;
  progressProps?: CircularProgressProps['sx'];
  thickness?: number;
  color?: string;
}

const CircularProgressWithValue: React.FC<ICircularProgress> = ({
  value,
  progressProps,
  thickness,
  color,
}) => {
  const size = 70;
  const defaultThickness = thickness || 3;
  const secColor = '#D9D9D9';

  const progressSx = {
    ...(progressProps || {}),
    color,
    minWidth: '30px',
    minHeight: '30px',
    borderRadius: '50%',
    boxShadow: `inset 0 0 0 ${(defaultThickness / 44) * size}px ${secColor}`,
  };

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        size={size}
        thickness={defaultThickness}
        value={value}
        sx={progressSx}
        variant="determinate"
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="h6"
          component="div"
          fontWeight="600"
          color={value > 0 ? color : undefined}
        >
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
};

export default CircularProgressWithValue;
